import {useNavigation} from '@react-navigation/core';
import {Button, Layout, Text} from '@ui-kitten/components';
import moment from 'moment';
import React from 'react';
import {StyleSheet} from 'react-native';
import {useSelector} from 'react-redux';
import {postRequestFreeTrial} from '../../../../apis';
import {DRAWER_ROUTES} from '../../../../navigation/constants';
import {px, useAsyncFn} from '../../../../utils';
import {LoadingButton, ProgressBar} from '../../../components';

const RequestTrialCard = ({data, handleCheckStatus}) => {
  const navigation = useNavigation();
  const kids = useSelector((state) => state.general.kids);

  const {gradeId, id: kidId} = kids?.[0] || {gradeId: null, id: null};

  const [
    {loading: requestLoading, value: requestResultMessage},
    handleRequestTrial,
  ] = useAsyncFn(async () => {
    await postRequestFreeTrial({gradeId, kidId});
    handleCheckStatus();
  }, [gradeId, kidId]);

  const showRequestButton = data?.canRequest && !requestResultMessage;

  if (!data?.showUI) {
    return null;
  }

  if (!data?.expireDate) {
    return (
      <Layout style={styles.container}>
        <Text style={styles.trailHeading}>{'Free Trial Classes'}</Text>
        <Text style={styles.text}>{requestResultMessage || data?.message}</Text>
        {showRequestButton && (
          <LoadingButton
            loading={requestLoading}
            onPress={() => handleRequestTrial()}>
            {'Request Trial'}
          </LoadingButton>
        )}
      </Layout>
    );
  }

  const remainingDays = moment(data?.expireDate).diff(moment(), 'day');
  const allDays = 7;
  const pastDays = allDays - remainingDays;
  const percent = (pastDays * 100) / allDays;
  return (
    <Layout style={styles.container}>
      {remainingDays >= 0 ? (
        <>
          <Text style={styles.trailHeading}>
            {'Your free trial will expire on'}
          </Text>
          <Text style={styles.trailHeading}>
            {moment(data?.expireDate).format('MMM D, YYYY')}
          </Text>
          <ProgressBar percent={percent} />
          <Text style={styles.text}>
            {remainingDays +
              ' days left before expiry date. Please buy subscription to resume the class.'}
          </Text>
        </>
      ) : (
        <>
          <Text style={styles.trailHeading}>
            {'Your free trial expired at'}
          </Text>
          <Text style={styles.trailHeading}>
            {moment(data?.expireDate).format('MMM D, YYYY')}
          </Text>
          <Text style={styles.text}>Please purchase Subscription</Text>
        </>
      )}

      <Button
        onPress={() => navigation.navigate(DRAWER_ROUTES.subscription.path)}>
        {'Buy Subscription'}
      </Button>
    </Layout>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: px(20),
    marginHorizontal: 31,
    paddingHorizontal: px(17),
    paddingTop: px(22),
    paddingBottom: px(20),
    borderColor: '#3A86FF',
    borderWidth: 2,
    borderRadius: 10,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.3,
    shadowRadius: 4.65,
    elevation: 8,
  },
  titleContainer: {
    paddingHorizontal: 0,
    marginTop: 0,
  },
  trailHeading: {
    fontSize: px(16),
    fontWeight: '600',
    textAlign: 'center',
  },
  text: {
    marginVertical: px(17),
    fontSize: px(16),
    textAlign: 'center',
  },
});

export default RequestTrialCard;
